import * as React from 'react';

import { IconActionChevronDownSmall16, IconMapPin16 } from '@cian/ui-kit-design-tokens/icons';
import { FilterButtonV2 } from 'shared/components/FilterButtonV2';

import styles from './GeoSuggestV2.css';

interface IGeoSuggestV2Props {
  label: string;
  onOpen: () => void;
  isSearchPage: boolean;
}

export const GeoSuggestV2: React.FC<React.PropsWithChildren<IGeoSuggestV2Props>> = ({
  label,
  onOpen,
  children,
  isSearchPage,
}) => {
  return (
    <div className={styles['container']}>
      <FilterButtonV2
        beforeIcon={isSearchPage ? <IconMapPin16 color="primary_100" /> : undefined}
        afterIcon={<IconActionChevronDownSmall16 color="primary_100" />}
        onClick={onOpen}
      >
        {label}
      </FilterButtonV2>
      {children}
    </div>
  );
};
